import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class StepProgressBarAPI extends ComponentAPI {
    getAllStepStatus() {
        return this.state.allStepStatus;
    }
    setAllStepStatus(allStepStatus) {
        this.setState({ allStepStatus });
    }
    getLeftText() {
        return this.state.leftText;
    }
    setLeftText(leftText) {
        this.setState({ leftText });
    }
}
export default StepProgressBarAPI;
//# sourceMappingURL=step-progress-bar-api.js.map